import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import useTable from "../components/useTable";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
import { SearchInput } from "../ui/inputs/Input";

const CatalogoComercio = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);

  const headCells = [
    {
      id: "ritm",
      label: "RITM",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "rif",
      label: "RIF",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombre",
      label: "NOMBRE",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "reprelegal",
      label: "CEDULA RESPONSABLE",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idcomercio.includes(target.value) ||
              (x.ritm !== null
                ? x.ritm.toLowerCase().includes(target.value.toLowerCase())
                : "") ||
              x.rif.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.codigocatastral !== null ? x.codigocatastral : "")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.reprelegal.includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarComerciosTodos = () => {
    let endpoint = `${op.conexion}/api/catalogo/comercios`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const handleCloseMensa = () => {
    setMostrar(false);
    seleccionarComerciosTodos();
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatCom();
  };

  const seleccionarLista = (index) => (event) => {
    cancelar();
    if (props.caja) {
      props.onHideAceptaCatCom(values[0]);
    } else if (props.llamado && props.llamado === 1) {
      props.onHideAceptaCatCom(values[0].rif);
    } else {
      props.onHideAceptaCatCom(
        values[0].idCome,
        values[0].nombre,
        values[0].codCat,
        values[0].repreLegal
      );
    }
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var idCome = recordsAfterPagingAndSorting()[index].idcomercio;
    var nombre = recordsAfterPagingAndSorting()[index].nombre;
    var codCat = recordsAfterPagingAndSorting()[index].codigocatastral;
    var repreLegal = recordsAfterPagingAndSorting()[index].reprelegal;
    var rif = recordsAfterPagingAndSorting()[index].rif;
    var direccion = recordsAfterPagingAndSorting()[index].direccion;

    var datos = [];

    datos.push({
      idCome,
      nombre,
      codCat,
      repreLegal,
      rif,
      direccion,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarComerciosTodos();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <Modal.Title>
          Seleccionar Comercio.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-6 m-0 mb-2 p-0">
            <SearchInput
                onChange={handleSearch}
            />
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idcomercio}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "80px",
                      }}
                    >
                      {item.ritm}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "80px",
                      }}
                    >
                      {item.rif}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                      }}
                    >
                      {item.nombre}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "150px",
                      }}
                    >
                      {item.reprelegal}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={activo}
          onClick={seleccionarLista()}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default CatalogoComercio;
